module.exports = __webpack_public_path__ + "static/gapsi-6c3e71a9b2e380ad0fb29e25645c6f41.png";